// Single RTK injection for Company CRUD against /api/company
import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const companyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Companies list tab (needsAttention | pastDue | trials | assignedToMe), paginated on the server.
    getCompanyTab: builder.query({
      query: (params = {}) => ({
        url: apiRoutes.company.tab.path,
        method: apiRoutes.company.tab.reqType,
        params,
      }),
      providesTags: ["Company"],
    }),
    // Active companies below the health cutoff, worst first: { total, companies }.
    getAtRiskCompanies: builder.query({
      query: (params = {}) => ({
        url: apiRoutes.company.atRisk.path,
        method: "GET",
        params,
      }),
      providesTags: ["Company"],
    }),
    getCompanyTabCounts: builder.query({
      query: () => ({
        url: apiRoutes.company.tabCounts.path,
        method: apiRoutes.company.tabCounts.reqType,
      }),
      providesTags: ["Company"],
    }),
    getAllCompany: builder.query({
      query: (params = {}) => ({
        url: apiRoutes.company.get.path,
        method: apiRoutes.company.get.reqType,
        params: params || {},
      }),
      providesTags: ["Company"],
    }),
    getAllCompanies: builder.query({
      query: (params = {}) => ({
        url: "/company/all",
        method: "GET",
        params: params || {},
      }),
      providesTags: ["Company"],
    }),
    // Own tag (not "Company") so a create/edit/archive elsewhere doesn't
    // force-refetch this org-wide aggregate on every company mutation -
    // only an explicit manual refresh (see useOrgStats) invalidates it.
    getCompanyStats: builder.query({
      query: () => ({
        url: "/company/stats",
        method: "GET",
      }),
      providesTags: ["CompanyStats"],
    }),
    createCompany: builder.mutation({
      query: (data) => ({
        url: apiRoutes.company.create.path,
        method: apiRoutes.company.create.reqType,
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    editCompany: builder.mutation({
      query: (data) => ({
        url: apiRoutes.company.edit.path,
        method: apiRoutes.company.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    deleteCompany: builder.mutation({
      query: (data) => ({
        url: apiRoutes.company.delete.path,
        method: apiRoutes.company.delete.reqType,
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    deleteCompanyImage: builder.mutation({
      query: (data) => ({
        url: "/uploads/companyProfileImage",
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    addNoteToCompany: builder.mutation({
      query: ({ id, note }) => ({
        url: `/company/addNote/${id}`,
        method: "POST",
        body: { note },
      }),
      invalidatesTags: ["Company"],
    }),
  }),
});

export const {
  useGetAllCompanyQuery,
  useGetCompanyTabQuery,
  useGetCompanyTabCountsQuery,
  useGetAtRiskCompaniesQuery,
  useGetAllCompaniesQuery,
  useGetCompanyStatsQuery,
  useCreateCompanyMutation,
  useEditCompanyMutation,
  useDeleteCompanyMutation,
  useDeleteCompanyImageMutation,
  useAddNoteToCompanyMutation,
} = companyApi;
